"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpenseViewType = void 0;
var ExpenseViewType;
(function (ExpenseViewType) {
    ExpenseViewType["EXPENSE"] = "expense";
    ExpenseViewType["ATM_WITHDRAWAL"] = "atmWithdrawal";
    ExpenseViewType["CASH_RETURNED"] = "cashReturned";
    ExpenseViewType["REIMBURSEMENT"] = "reimbursement";
    ExpenseViewType["TRANSFER_REFUND"] = "transferRefund";
})(ExpenseViewType = exports.ExpenseViewType || (exports.ExpenseViewType = {}));
//# sourceMappingURL=expenses.js.map